import React from 'react';
const REGEX_SPECIALS = /[.*+?^${}()|[\]\\]/g;
/**
 * Returns `text` as React nodes with every case-insensitive match of `term` wrapped in `<mark>`. Accents are NOT
 * folded, mirroring the server rule (`LOWER ... LIKE`).
 */
export function highlight(text, term) {
    const source = text !== null && text !== void 0 ? text : '';
    const needle = (term !== null && term !== void 0 ? term : '').trim();
    if (!source || !needle)
        return source;
    const pattern = new RegExp(needle.replace(REGEX_SPECIALS, '\\$&'), 'gi');
    const nodes = [];
    let cursor = 0;
    let match = pattern.exec(source);
    while (match !== null) {
        const start = match.index;
        const end = start + match[0].length;
        if (start > cursor)
            nodes.push(source.slice(cursor, start));
        nodes.push(React.createElement('mark', { key: `${start}-${end}` }, match[0]));
        cursor = end;
        match = pattern.exec(source);
    }
    if (cursor === 0)
        return source;
    if (cursor < source.length)
        nodes.push(source.slice(cursor));
    return nodes;
}
